<template>
  <article class="course-card card" @click="$emit('click')">
    <div class="course-card__header">
      <h3 class="course-card__title">
        {{ course.category }} | {{ course.title }}
      </h3>
      <span class="course-card__price">¥{{ course.price }}</span>
    </div>
    <div class="course-card__tags">
      <span v-for="tag in course.tags" :key="tag" class="tag">{{ tag }}</span>
    </div>
    <p class="course-card__desc">{{ course.description }}</p>
    <div class="course-card__teacher">
      <div class="avatar avatar--sm" />
      <div>
        <p class="course-card__teacher-name">{{ course.teacher.name }}</p>
        <p class="course-card__teacher-info">{{ course.teacher.info }}</p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'CourseCard',
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  emits: ['click'],
}
</script>

<style scoped>
.course-card {
  padding: 16px;
  width: 280px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

@media (min-width: 768px) {
  .course-card {
    width: auto;
  }
}

.course-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}

.course-card__title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  flex: 1;
}

.course-card__price {
  font-size: 16px;
  font-weight: 700;
  color: var(--color-accent);
  white-space: nowrap;
}

.course-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.course-card__desc {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.6;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 12px;
}

.course-card__teacher {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border);
}

.course-card__teacher-name {
  font-size: 13px;
  font-weight: 600;
}

.course-card__teacher-info {
  font-size: 11px;
  color: var(--color-text-light);
  margin-top: 2px;
}
</style>
